import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DateHelperServiceService {
  constructor() {}

  displayDate = (dateString: Date) => {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    return `${year}-${month}-${day}`;
  };

  displayDateTime = (dateString: Date) => {
    const date = new Date(dateString);
    const hr = date.getHours();
    const mins = date.getMinutes();

    return `${this.displayDate(dateString)} ${hr}:${mins}`;
  };
}
